import React, { useState } from 'react'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as st from '~/assets/styl/Plants.module.styl'
import { Button, Lightbox } from '~/components'
import { Image } from '~/components/Lightbox'
import { plants, humanizedPlants } from '~/data'
import cn from 'classnames'
import { useLanguage } from '~/hooks'

export default function Plants() {
  const breakpoints = useBreakpoint()

  const [type, setType] = useState(-1)

  const [index, setIndex] = useState(0)
  const [images, setImages] = useState<Image[]>(null)
  const language = process.env.GATSBY_LANGUAGE
  const zoom = (index: number, humanized = false) => {
    setIndex(0)
    setImages([
      {
        url: humanized ? humanizedPlants[index] : plants[index],
      },
    ])
  }
  const { t } = useLanguage()
  return (
    <>
      <section id="Plantas" className={st.core}>
        <div>
          <h2>{t('Plants.title')}</h2>
          <ul>
            <li
              className={cn({ [st.active]: type === 0 })}
              onClick={() => setType(0)}
            >
              2 {t('Plants.suites')}
            </li>
            <li
              className={cn({ [st.active]: type === 1 })}
              onClick={() => setType(1)}
            >
              3 {t('Plants.suites')}
            </li>
            <li
              className={cn({ [st.active]: type === 2 })}
              onClick={() => setType(2)}
            >
              {t('Plants.dormAndSuite')}
            </li>
          </ul>
          {!breakpoints.sm && (
            <>
              <h3>{t('Plants.plantsHuman')}</h3>
              <ul>
                <li onClick={() => zoom(0, true)}>
                  <span className="icon-camera"></span>
                  {t('Plants.terro')}
                </li>
                <li onClick={() => zoom(1, true)}>
                  <span className="icon-camera"></span>
                  {t('Plants.beiraMar')}
                </li>
              </ul>
            </>
          )}
        </div>
        <div
          className={
            language === 'pt' ? st.pt : language === 'es' ? st.es : st.en
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1071.286 548.933"
          >
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(19)}
            >
              <path
                d="M956.537,320.81H853.463v12.884h-53.81v57.979h28.989v16.295h99.095v-9.095h28.8Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(569.299 157.72)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  04
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(18)}
            >
              <path
                d="M956.537,497.126H853.463V484.242h-53.81V426.263h28.989V409.968h99.095v9.095h28.8Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(569.299 246.878)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  03
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(16)}
            >
              <path
                d="M1199.521,410l-29.006-84.4h-97.262v9.095H958.537v25.011H1005.8v37.137h105.347V410Z"
                transform="translate(-308.68 -211.661)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(770.358 161.438)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  01
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(17)}
            >
              <path
                d="M1223.13,480.695,1199.521,412H1005.8v24.737H982.305v34.105h90.947v9.853Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(793.922 239.678)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  02
                </tspan>
              </text>
            </g>
            <path
              d="M1109.147,398.842H1003.8V361.705H958.537v39.168h-28.8v15.811h28.8v18.053H1003.8V410h105.347Z"
              transform="translate(-308.796 -211.67)"
              fill="#edf0e8"
            />
            <g
              className={cn({ [st.active]: type === 0 })}
              onClick={() => zoom(11)}
            >
              <path
                d="M638.474,588.337v12.632H621.295v33.347H611.189v34.358h83.874v-6.568h29.81V588.337Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(359.358 421.438)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  04
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 0 })}
              onClick={() => zoom(10)}
            >
              <path
                d="M638.474,751.01V738.379H621.295V705.031H611.189V670.674h83.874v6.568h29.81V751.01Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(359.358 504.438)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  03
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(8)}
            >
              <path
                d="M866.347,586.337V575.716H758.221v12.632H726.874v22.358h31.347v45.832h30.253v5.984H888.516V649.989h30.379V586.337Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(514.088 412.448)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  01
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(9)}
            >
              <path
                d="M866.347,740.705v10.621H758.221V738.695H726.874V677.337h31.347v-6.832h30.253v-5.984H888.516v12.532h30.379v63.653Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(514.088 501.254)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  02
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(15)}
            >
              <path
                d="M972.453,578.221v8.116H920.895v63.505h29.2v12.679h96.632v-5.479h30.695V578.221Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(690.361 413.701)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  04
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(14)}
            >
              <path
                d="M972.453,748.821v-8.116H920.895V677.2h29.2V664.521h96.632V670h30.695v78.821Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(690.361 500.001)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  03
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(12)}
            >
              <path
                d="M1319.741,677.126l-29-84.368h-96.5v9.716H1079.421v54.568h45.474v6.479h106.863v13.605Z"
                transform="translate(-308.796 -211.67)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(899.785 428.272)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  01
                </tspan>
              </text>
            </g>
            <path
              d="M756.221,658.537V612.81H726.874v51.295h-29.81v11.232h59.158v-7.116h30.253v-9.684Z"
              transform="translate(-308.796 -211.67)"
              fill="#edf0e8"
            />
            <rect
              width="57.579"
              height="23.211"
              transform="translate(581.72 440.319)"
              fill="#edf0e8"
            />
            <path
              d="M1229.758,665.521H1122.895v-6.479h-74.168v8.632h30.695v45.187h43.474V677.126h106.863Z"
              transform="translate(-308.796 -211.67)"
              fill="#edf0e8"
            />
            <g
              className={cn({ [st.active]: type === 2 })}
              onClick={() => zoom(2)}
            >
              <path
                d="M362.576,681.1l7.815,4.651-27.65,46.457,45.589,27.134,15.5-26.051,8.249,4.91,52.2-87.7-5.671-3.376L473.859,621.5l-36.01-21.432-12.157-7.236-7.815-4.651Z"
                transform="translate(-308.061 -212.466)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(105.235 464.016) rotate(-59)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  03
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 0 })}
              onClick={() => zoom(1)}
            >
              <path
                d="M471.212,654.621l-5.21-3.1-48.84,82.06,31.731,18.886,12.662-21.275,26.883,16,25.712-43.2,2.605,1.55,25.712-43.2-2.605-1.55-18.236-10.853-18.67-11.112L493.84,633.4,486.459,629Z"
                transform="translate(-308.061 -212.466)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(183.762 484.196) rotate(-59)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  02
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 0 })}
              onClick={() => zoom(3)}
            >
              <path
                d="M487.912,470.514,418.9,586.467l56.036,33.352,59.188-99.445-38.678-23.021,9.825-16.508Z"
                transform="translate(-308.061 -212.466)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(172.248 348.655) rotate(-59)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  04
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 0 })}
              onClick={() => zoom(4)}
            >
              <path
                d="M488.935,468.795l17.358,10.331,12.668-21.284,38.624,22.988L616.762,381.4l-38.624-22.988-14.328-8.528-3.03-1.8Z"
                transform="translate(-308.061 -212.466)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(253.176 208.696) rotate(-59)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  05
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 0 })}
              onClick={() => zoom(5)}
            >
              <path
                d="M642.583,278.293l-29.732-17.7L561.8,346.365l55.982,33.319,14.224-23.9,3.5,2.083,48.324-81.192-29.75-17.707Z"
                transform="translate(-308.061 -212.466)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(312.986 109.438) rotate(-59)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  06
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(6)}
            >
              <path
                d="M637.228,358.893l7.381,4.393-14.224,23.9,52.762,31.4,30.891-51.9,8.466,5.039,41.863-70.337-34.847-20.741,4.651-7.815L700.41,252.736Z"
                transform="translate(-308.061 -212.466)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(393.602 122.817) rotate(-59)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  07
                </tspan>
              </text>
            </g>
            <path
              d="M641.867,363.982l-9.163-5.454L558.41,483.355l-38.624-22.988-21.6,36.29,38.624,22.988L461.354,646.426l9.163,5.454L545.974,525.1l38.8,23.026,21.6-36.29-38.8-23.026Z"
              transform="translate(-308.061 -212.466)"
              fill="#edf0e8"
            />
            <text
              transform="translate(104.992 208.305) rotate(-59)"
              fill="#1d1d1b"
              fontSize="16"
              fontFamily="Avenir"
              letterSpacing="0.05em"
            >
              <tspan x="-91.128" y="0">
                {t('Plants.addrees')}
              </tspan>
            </text>
            <path
              d="M0,0H446.622"
              transform="translate(230.027 33.894) rotate(121)"
              fill="none"
              stroke="#e3ebdb"
              strokeWidth="8"
            />
            <g
              className="beira-mar"
              transform="translate(893.858 4764.415) rotate(-90)"
            >
              <path
                d="M4460,108a40.746,40.746,0,0,1,30,4"
                fill="none"
                stroke="#e3ebdb"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
              <path
                d="M4430,112a14.5,14.5,0,0,1,20,0,14.347,14.347,0,0,0,10-4"
                fill="none"
                stroke="#e3ebdb"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
              <path
                d="M4460,123a40.746,40.746,0,0,1,30,4"
                fill="none"
                stroke="#e3ebdb"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
              <path
                d="M4430,127a14.5,14.5,0,0,1,20,0,14.347,14.347,0,0,0,10-4"
                fill="none"
                stroke="#e3ebdb"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
              <path
                d="M4460,138a40.746,40.746,0,0,1,30,4"
                fill="none"
                stroke="#e3ebdb"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
              <path
                d="M4430,142a14.5,14.5,0,0,1,20,0,14.347,14.347,0,0,0,10-4"
                fill="none"
                stroke="#e3ebdb"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
            </g>
            <text
              transform="translate(1061.858 304.415) rotate(-90)"
              fill="#1d1d1b"
              fontSize="16"
              fontFamily="Avenir"
              letterSpacing="0.05em"
            >
              <tspan x="-88.312" y="0">
                {t('Plants.beiraMarAndSJ')}
              </tspan>
            </text>
            <g className={cn({ [st.active]: type === 0 })}>
              <path
                d="M1259.117,234.366l3.132,41.9,11.46-11.3Z"
                transform="translate(-11030.606 5767.634)"
                fill="#e3ebdb"
              />
              <path
                d="M1289.7,263.178l-15.991,1.792-14.591-30.6"
                transform="translate(-11030.606 5767.634)"
                fill="#1d1d1b"
              />
              <path
                d="M-4.026-8.5h2.544l3.612,5.9h.024V-8.5H4.026V0H1.578L-2.13-6.048h-.024V0H-4.026Z"
                transform="translate(-9774.489 5995.855)"
                fill="#1d1d1b"
              />
            </g>
            <text
              transform="translate(691.358 89.415)"
              fill="#1d1d1b"
              fontSize="16"
              fontFamily="Avenir"
              letterSpacing="0.05em"
            >
              <tspan x="-35.752" y="0">
                {t('Plants.tower')} C
              </tspan>
            </text>
            <text
              transform="translate(158.613 239.429) rotate(-59)"
              fill="#1d1d1b"
              fontSize="16"
              fontFamily="Avenir"
              letterSpacing="0.05em"
            >
              <tspan x="-35.608" y="0">
                {t('Plants.tower')} A
              </tspan>
            </text>
            <text
              transform="translate(463.358 342.415)"
              fill="#1d1d1b"
              fontSize="16"
              fontFamily="Avenir"
              letterSpacing="0.05em"
            >
              <tspan x="-40.008" y="0">
                {t('Plants.tower')} B1
              </tspan>
            </text>
            <text
              transform="translate(816.358 342.415)"
              fill="#1d1d1b"
              fontSize="16"
              fontFamily="Avenir"
              letterSpacing="0.05em"
            >
              <tspan x="-40.008" y="0">
                {t('Plants.tower')} B2
              </tspan>
            </text>
            <g
              className={cn({ [st.active]: type === 1 })}
              onClick={() => zoom(13)}
            >
              <path
                d="M14252.089,8131.695v-8.925H14188.3v.029h-49v-26h44.441V8061h195.536l24.295,70.695Z"
                transform="translate(-13367.643 -7593.562)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(926.014 507.804)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  02
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 0 })}
              onClick={() => zoom(7)}
            >
              <path
                d="M616.762,468.795,599.4,479.126l-12.668-21.284L548.112,480.83,488.935,381.4l38.624-22.988,14.328-8.528,3.03-1.8Z"
                transform="matrix(0.477, 0.879, -0.879, 0.477, 423.269, -435.337)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(327.051 244.452) rotate(-59)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  08
                </tspan>
              </text>
            </g>
            <g
              className={cn({ [st.active]: type === 0 })}
              onClick={() => zoom(0)}
            >
              <path
                d="M465.111,470.514l69.013,115.953-56.037,33.352L418.9,520.373l38.678-23.02-9.825-16.508Z"
                transform="matrix(0.477, 0.879, -0.879, 0.477, 496.082, -301.207)"
                fill="#fff"
                stroke="#e3ebdb"
                strokeWidth="3"
              />
              <text
                transform="translate(239.112 390.336) rotate(-59)"
                fill="#1d1d1b"
                fontSize="16"
                fontFamily="Avenir"
                fontWeight="900"
              >
                <tspan x="-9.472" y="0">
                  01
                </tspan>
              </text>
            </g>
          </svg>

          {!breakpoints.sm && (
            <Button href="#FaleConosco">{t('Plants.bunttonContact')}</Button>
          )}
        </div>
        {breakpoints.sm && (
          <div>
            <h3>{t('Plants.plantsHuman')}</h3>
            <ul>
              <li onClick={() => zoom(0, true)}>
                <span className="icon-camera"></span>
                {t('Plants.terro')}
              </li>
              <li onClick={() => zoom(1, true)}>
                <span className="icon-camera"></span>
                {t('Plants.beiraMar')}
              </li>
            </ul>

            <Button href="#FaleConosco">{t('Plants.bunttonContact')}</Button>
          </div>
        )}
      </section>

      <Lightbox
        index={index}
        images={images}
        setIndex={setIndex}
        setImages={setImages}
      />
    </>
  )
}
